export default "__VITE_ASSET__QVmueT4s__"